// extracted by mini-css-extract-plugin
export default {"link":"styles_link__SaEme","linkActive":"styles_linkActive__MgNI9"};